import lodash from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { financeSupporterAllSelector } from "store/bailiff/finance/supporter/finance_supporter.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDataFinance = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const finance = useSelector(financeSupporterAllSelector);
  const data = lodash.orderBy(finance, "setAt", "desc") || [];

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data };
};
